import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'
import { getValues, prepareValues } from '@/lib/values'

export const meeting_edit = {

  namespaced: true,

  state: {
    values: {},
    assigned: [],
    slots: {},
    entities: [],
    filters: [
      { column: 'last_name', label: 'last_name', options: { type: false }, value: '', status: true },
    ],
    options: {
      last_name: { label: 'last_name', element: 'text' },
    },
    persons: [],
  },

  getters: {
    values: state => state.values,
    assigned: state => state.assigned,
    slots: state => state.slots,
    entities: state => state.entities,
    filters: state => state.filters,
    options: state => state.options,
    persons: state => state.persons,
  },

  mutations: {
    setValues(state, values) { state.values = values },
    setAssigned(state, assigned) { state.assigned = assigned },
    setSlots(state, slots) { state.slots = slots },
    setEntities(state, entities) { state.entities = entities },
    setOptions(state, options) { state.options = options },
    setPersons(state, persons) { state.persons = persons },
    clearFilters(state) {
      state.filters = [
        { column: 'last_name', label: 'last_name', options: { type: false }, value: '', status: true },
      ];
      state.options = {
        last_name: { label: 'last_name', element: 'text' },
      };
    },
  },

  actions: {

    getEntities: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Meeting'],
      form_display: true,
    }}),

    async getForm({ rootState, commit, dispatch }) {
      commit('setEntities', []);
      const entities = await dispatch('getEntities');
      commit('setProgress', false, { root: true });
      commit('setValues', getValues('meeting', entities.data['App\\Models\\Meeting']));
      commit('setAssigned', rootState.meeting.meeting.persons || []);
      commit('setEntities', entities.data['App\\Models\\Meeting']);
    },

    async createSession(state, values) {
      const session = await Vue.axios.post(API_URL + '/meetings/' + router.currentRoute.params.id + '/transform', values);
      router.push('/session/' + session.data.id + '/edit');
    },

    async validateMeeting({ state, rootState, commit, dispatch }) {
      if (!rootState.progress) {
        let values = prepareValues(state.values, 'text_');
        try {
          await Vue.axios.post(API_URL + '/validate?model=App\\Models\\Meeting', values, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
        } catch (error) {
          commit('setProgress', false, { root: true });
          commit('setResponse', { status: true, type: 'error', message: 'form_error', errors: error.response.data.errors }, { root: true });
          return;
        }
        dispatch(((!router.currentRoute.params.id) ? 'create' : 'update') + 'Meeting', values);
      }
    },

    async createMeeting({ commit }, values) {
      const response = await Vue.axios.post(API_URL + '/meetings', values);
      commit('setProgress', false, { root: true });
      commit('setResponse', { status: true, type: 'success', message: 'meeting_successfully_created' }, { root: true });
      router.push('/meeting/' + response.data.id + '/edit');
    },

    async updateMeeting({ state, rootState, commit, dispatch }) {
      const meeting = await Vue.axios.put(API_URL + '/meetings/' + router.currentRoute.params.id, state.values);
      commit('setProgress', false, { root: true });
      commit('setResponse', { status: true, type: 'success', message: 'meeting_successfully_updated' }, { root: true });
      await dispatch('meeting/getMeeting', {}, { root: true });
      commit('meeting/setMeeting', meeting.data, { root: true });
      commit('setValues', getValues('meeting', state.entities));
      commit('setAssigned', rootState.meeting.meeting.persons || []);
      dispatch('getSlots');
    },

    addParticipant({ state, rootState, commit, dispatch }, id) {
      if (!rootState.progress) {
        state.values.persons = state.assigned.reduce((carry, participant) => {
          carry.push(participant.id);
          return carry;
        }, []).concat([id]);
        commit('setPersons', state.persons.filter(person => id != person.id));
        dispatch('updateMeeting');
      }
    },

    removeParticipant({ state, rootState, dispatch }, id) {
      if (!rootState.progress) {
        state.values.persons = state.assigned.reduce((carry, participant) => {
          carry.push(participant.id);
          return carry;
        }, []);
        state.values.persons.splice(state.values.persons.indexOf(id), 1);
        dispatch('updateMeeting');
      }
    },

    async getSlots({ rootState, commit }) {
      let persons = rootState.meeting.meeting.persons.reduce((carry, participant) => {
        carry.push(participant.id);
        return carry;
      }, []);
      if (persons.length > 0) {
        const slots = await Vue.axios.get(API_URL + '/meetings/' + router.currentRoute.params.id + '/slots', {
          params: {
            persons: persons.join(',')
          }
        });
        commit('setProgress', false, { root: true });
        commit('setSlots', slots.data);
      }
    },

    async getPersons({ state, rootState, getters, commit }) {
      if (!rootState.progress) {
        let assigned = state.assigned.reduce((carry, participant) => {
          carry.push(participant.id);
          return carry;
        }, []);
        const persons = await Vue.axios.get(API_URL + '/persons', {
          params: {
            filters: getters.filters.concat([
              { column: 'id', not: true, value: assigned.join(','), status: true },
            ]),
            limit: 200,
          }
        });
        commit('setProgress', false, { root: true });
        commit('setPersons', persons.data.items);
      }
    },

  }
}
